"use strict";

import { StyleSheet } from 'react-native';
export const styles = StyleSheet.create({
  container: {
    position: 'absolute',
    left: 0,
    top: 0,
    right: 0
  }
});
//# sourceMappingURL=styles.js.map